import house from '../703house.png'

function Carousel(images) {
    return(
        <div align="center">
            <img src={house} alt="Our 1907 house" width="100%" />
        </div>
    )
}

export default Carousel
